import React from "react";
import styled from "styled-components";
import ButtonDivider from "@common/LifeAtButton/ButtonDivider";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";

const SummaryElementHeader = styled.div`
    font-size: ${FontSize.small};
    color: ${(props) => props.theme.textColorPrimary};
    text-align: center;
`;

const SummaryElementContent = styled.div`
    font-size: ${FontSize.large};
    color: ${(props) => props.theme.textColorSpecial};
    text-align: center;
    padding-top: 5px;
`;

const SummaryWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    width: 100%;
    background-color: ${(props) => props.theme.backgroundSpecial};
    padding: 15px;
    border-radius: ${Styles.borderRadiusNormal};
`;

interface UserMetricSummaryViewProps {
    readonly metrics: { title: string; content: string }[];
}
const getSummaryElements = (metricElements: { title: string; content: string }[]): React.ReactElement[] => {
    const summaryElements: React.ReactElement[] = [];
    metricElements.map((element, index) => {
        summaryElements.push(
            <div key={`user-metrics-summary-element-${index}`} className={`summary-element`}>
                <SummaryElementHeader>{element.title}</SummaryElementHeader>
                <SummaryElementContent>{element.content}</SummaryElementContent>
            </div>,
        );

        if (index !== metricElements.length - 1) {
            summaryElements.push(<ButtonDivider key={`user-metrics-summary-element-divider-${index}`} />);
        }
    });
    return summaryElements;
};

export default function UserMetricSummaryView(props: UserMetricSummaryViewProps) {
    return <SummaryWrapper className={`summary-wrapper`}>{getSummaryElements(props.metrics)}</SummaryWrapper>;
}
